import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface ICheckConnectionParams {
  id: string;       // Data source id
  server?: string;
  port?: string;
  username?: string;
  embedPassword?: boolean;
  encryptedPassword?: string;
  encryptedPasswordKeyId?: string;
}

export interface ICheckConnectionResult extends IResult {
  succeeded: boolean;
  messages: string[]; // Messages are strings from the DataSourceException thrown and will not be localized.
}

export class CheckConnectionRequest extends Request<ICheckConnectionParams, ICheckConnectionResult> {
  constructor(params: ICheckConnectionParams) {
    super('checkConnection', params);
  }
}
